// client/src/components/dashboard/HomePanels.jsx
// R34f5 — refonte design : quêtes façon Hearthstone (cartes avec reroll
// individuel) + passe newbie en piste de 7 jalons + panneau saison.
import React, { useEffect, useState, useCallback } from 'react';
import { getQuests, claimDaily, rerollDaily, claimNewbie } from '../../api/questService';
import { getSeasonState, claimSeasonReward } from '../../api/seasonService';
import './HomePanels.css';

const TIER_LABELS = {
  Bronze: '🥉 Bronze', Argent: '🥈 Argent', Or: '🥇 Or',
  Platine: '💠 Platine', Diamant: '💎 Diamant', Maître: '🔮 Maître', Légendaire: '👑 Légendaire',
};

export const QuestPanel = () => {
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const reload = useCallback(async () => {
    const s = await getQuests();
    setState(s);
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const act = async (fn, okMsg) => {
    setBusy(true); setMsg(null);
    try {
      const r = await fn();
      if (r && r.success === false) setMsg(r.message || 'Action impossible');
      else if (okMsg) setMsg(okMsg);
      await reload();
      window.dispatchEvent(new Event('wallet:refresh'));
    } catch (e) {
      setMsg('Erreur réseau');
    } finally { setBusy(false); }
  };

  if (!state || state.success === false) return null;

  const newbie = state.newbie || [];
  const activeDay = newbie.find((d) => !d.claimed);

  return (
    <section className="hp-panel">
      <header className="hp-head">
        <h2 className="hp-title">📜 Quêtes du jour</h2>
        <span className="hp-head-sub">Rafraîchies chaque matin</span>
      </header>

      <div className="hp-quest-cards">
        {(state.quests || []).map((q) => {
          const done = (q.progress || 0) >= q.goal;
          const pct = Math.min(100, Math.round(((q.progress || 0) / q.goal) * 100));
          return (
            <article key={q.id} className={`hp-qcard ${q.claimed ? 'is-claimed' : done ? 'is-done' : ''}`}>
              <div className="hp-qcard-glow" />
              <div className="hp-qcard-main">
                <div className="hp-qcard-head">
                  <span className="hp-qcard-title">{q.title}</span>
                  <span className="hp-qcard-reward">💰 {q.reward}</span>
                </div>
                <div className="hp-qcard-bar"><div className="hp-qcard-fill" style={{ width: pct + '%' }} /></div>
                <div className="hp-qcard-foot">
                  <span className="hp-qcard-count">{Math.min(q.progress || 0, q.goal)}/{q.goal}</span>
                  {q.claimed ? (
                    <span className="hp-badge hp-badge-done">✅ Réclamée</span>
                  ) : done ? (
                    <button type="button" className="hp-claim-btn" disabled={busy}
                      onClick={() => act(() => claimDaily(q.id), `+${q.reward} pièces !`)}>
                      ✨ Réclamer
                    </button>
                  ) : (
                    <span className="hp-badge hp-badge-todo">En cours</span>
                  )}
                </div>
              </div>
              {!q.claimed && q.canReroll && (
                <button type="button" className="hp-reroll-btn" title="Changer cette quête (1×)"
                  disabled={busy} onClick={() => act(() => rerollDaily(q.id), 'Quête remplacée !')}>
                  🔄
                </button>
              )}
            </article>
          );
        })}
      </div>

      {activeDay && (
        <div className="hp-pass">
          <header className="hp-head">
            <h3 className="hp-title hp-sub">🎓 Passe de bienvenue</h3>
            <span className="hp-head-sub">Jour {activeDay.day}/7</span>
          </header>
          <ol className="hp-pass-track">
            {newbie.map((d) => {
              const done = (d.progress || 0) >= d.goal;
              return (
                <li key={d.day} className={`hp-node ${d.claimed ? 'is-claimed' : done ? 'is-done' : ''}`}>
                  <span className="hp-node-dot">J{d.day}</span>
                  <span className="hp-node-mission">{d.mission}</span>
                  <span className="hp-node-goal">{Math.min(d.progress || 0, d.goal)}/{d.goal}</span>
                  <span className="hp-node-reward">
                    💰 {d.reward.coins}{d.reward.packPremium ? ' 📦' : ''}
                  </span>
                  {d.claimed ? <span className="hp-node-check">✅</span> : done ? (
                    <button type="button" className="hp-claim-btn hp-node-btn" disabled={busy}
                      onClick={() => act(() => claimNewbie(d.day), 'Récompense reçue !')}>
                      Réclamer
                    </button>
                  ) : <span className="hp-node-lock">🔒</span>}
                </li>
              );
            })}
          </ol>
          <p className="hp-pass-note">📦 J7 : pack premium (5 cartes Rare/Super-Rare) en bonus</p>
        </div>
      )}
      {msg && <p className="hp-msg">{msg}</p>}
    </section>
  );
};

export const SeasonPanel = () => {
  const [st, setSt] = useState(null);
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { getSeasonState().then(setSt); }, []);

  const doClaim = async () => {
    setBusy(true); setMsg(null);
    try {
      const r = await claimSeasonReward();
      if (r.success === false) setMsg(r.message);
      else {
        setMsg(`Récompense reçue : ${r.coins} pièces${r.cards && r.cards.length ? ` + ${r.cards.length} carte(s)` : ''}${r.orin ? ` + ${r.orin} ORIN` : ''} !`);
        setSt(await getSeasonState());
        window.dispatchEvent(new Event('wallet:refresh'));
      }
    } catch { setMsg('Erreur réseau'); }
    finally { setBusy(false); }
  };

  if (!st || st.success === false || !st.season) return null;

  const daysLeft = Math.max(0, Math.ceil((new Date(st.season.endsAt) - Date.now()) / 86400000));

  return (
    <section className="hp-panel hp-season">
      <header className="hp-head">
        <h2 className="hp-title">⚔️ {st.season.name}</h2>
        {!st.ended && <span className="hp-head-sub">{daysLeft > 0 ? `${daysLeft} j restants` : 'Dernier jour !'}</span>}
      </header>
      {st.ended ? (
        <>
          <p className="hp-season-result">
            Saison terminée — Rang final : <strong>{TIER_LABELS[st.myTier] || st.myTier}</strong>
            {st.myPosition ? ` · ${st.myPosition}ᵉ` : ''}
          </p>
          {st.claimed
            ? <p className="hp-badge hp-badge-done">✅ Récompense réclamée</p>
            : <button type="button" className="hp-claim-btn hp-claim-season" disabled={busy} onClick={doClaim}>
                🎁 Réclamer ma récompense
              </button>}
          {msg && <p className="hp-msg">{msg}</p>}
          <details className="hp-top10">
            <summary>Top 10 final</summary>
            <ol>
              {(st.top10 || []).map((r) => (
                <li key={r.uid}>{r.username} — {r.elo} ({TIER_LABELS[r.tier] || r.tier})</li>
              ))}
            </ol>
          </details>
        </>
      ) : (
        <>
          <p className="hp-season-tier">Ton rang : <strong>{TIER_LABELS[st.myTier] || st.myTier}</strong></p>
          <p className="hp-season-pot">
            Pot Top 10 : <strong>{st.season.topTenOrinBudget} ORIN</strong>{' '}
            <span className="hp-soon">(Bientôt disponible — blockchain)</span>
          </p>
          <details className="hp-rewards-preview">
            <summary>Récompenses de fin de saison</summary>
            <ul>
              <li>🥉 Bronze : 100 pièces</li>
              <li>🥈 Argent : 300 pièces</li>
              <li>🥇 Or : 500 pièces</li>
              <li>💠 Platine : 800 pièces</li>
              <li>💎 Diamant : 1 000 pièces + carte aléatoire (min. Rare)</li>
              <li>🔮 Maître : 1 500 pièces + carte aléatoire (min. Super-Rare)</li>
              <li>👑 Légendaire : 2 000 pièces + pack premium</li>
              <li>👑 Top 10 Légendaire : bonus ORIN</li>
            </ul>
          </details>
        </>
      )}
    </section>
  );
};
